exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2o7JgGJfrbZypyXU_FP2uE{padding-left:20px;padding-right:20px}@media only screen and (min-width: 480px){._2o7JgGJfrbZypyXU_FP2uE{padding-left:36px;padding-right:36px}}@media only screen and (min-width: 1280px){._2o7JgGJfrbZypyXU_FP2uE{padding-left:52px;padding-right:52px}}._2aE4yudK-PElnfW_BPBncP{margin-left:20px;margin-right:20px}@media only screen and (min-width: 480px){._2aE4yudK-PElnfW_BPBncP{margin-left:36px;margin-right:36px}}@media only screen and (min-width: 1280px){._2aE4yudK-PElnfW_BPBncP{margin-left:52px;margin-right:52px}}music-app{--music-color-background: transparent;height:auto;position:relative}music-app._1fXUhbZV4O3jv0ZjjHMqOq{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1YMF-O3ms5OvKyXJPRYZvZ{height:auto}._2Xl9RFk0jCkag_pxqI9BhW{visibility:hidden;opacity:0}._30BrqWjGGks-bmFxu91P5X{filter:blur(32px);overflow-y:hidden}._30BrqWjGGks-bmFxu91P5X nav{display:none}\n", ""]);

// exports
exports.locals = {
	"grid-sides": "_2o7JgGJfrbZypyXU_FP2uE",
	"gridSides": "_2o7JgGJfrbZypyXU_FP2uE",
	"grid-sides-margins": "_2aE4yudK-PElnfW_BPBncP",
	"gridSidesMargins": "_2aE4yudK-PElnfW_BPBncP",
	"select-disabled": "_1fXUhbZV4O3jv0ZjjHMqOq",
	"selectDisabled": "_1fXUhbZV4O3jv0ZjjHMqOq",
	"view-container": "_1YMF-O3ms5OvKyXJPRYZvZ",
	"viewContainer": "_1YMF-O3ms5OvKyXJPRYZvZ",
	"hidden": "_2Xl9RFk0jCkag_pxqI9BhW",
	"blur-content": "_30BrqWjGGks-bmFxu91P5X",
	"blurContent": "_30BrqWjGGks-bmFxu91P5X"
};